import script from "./JoinRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinRoom.vue?vue&type=script&setup=true&lang=js"

import "./JoinRoom.vue?vue&type=style&index=0&id=1aa1fd5c&lang=css"

const __exports__ = script;

export default __exports__